import { Grid, IconButton } from '@mui/material';
import { t } from 'i18next';
import { memo } from 'react';
import FormActionButtons from 'components/ui/form/FormActionButtons';
import FormCurrencyField from 'components/ui/form/FormCurrencyField';
import FormNumberField from 'components/ui/form/FormNumberField';
import FormRadioGroupField from 'components/ui/form/FormRadioGroupField';
import FormTextField from 'components/ui/form/FormTextField';
import FormSimpleSelectField from 'components/ui/form/FormSimpleSelectField';
import {
  repairTypeSelectOptions,
  residentTypeSelectOptions,
} from 'shared/selectOptionsList';
import CurrencySubContent from 'components/ui/text-formats/CurrencySubContent';
import { Trans } from 'react-i18next';
import { currencyTypeSelectOptions } from 'shared/selectOptionsList';
import useCurrency from 'hooks/useCurrency';
import { useShowroom } from 'context';

export default memo(function ShaxmatkaAddHome({
  editTypeMultiple,
  handleEditType,
  formik,
  isSubmitting,
  isMultipleSubmitting,
}) {
  const [, dispatch] = useShowroom();
  const { currencyData } = useCurrency();
  const handleCloseHomeDetail = () => {
    formik.resetForm();
    dispatch({ type: 'setHomeExpanded', payload: false });
    dispatch({ type: 'setFreePlaceData', payload: {} });
  };
  const handleCurrencyChange = (value) => {
    formik.setFieldValue('isvalute', value, true);
    if (currencyData && currencyData.sum) {
      if (value == '1') {
        formik.setFieldValue(
          'repaired',
          parseFloat((formik.values.repaired || '0') / currencyData.sum),
          true,
        );
        formik.setFieldValue(
          'norepaired',
          parseFloat((formik.values.norepaired || '0') / currencyData.sum),
          true,
        );
        formik.setFieldValue(
          'deal_price',
          parseFloat((formik.values.deal_price || '0') / currencyData.sum),
          true,
        );
        formik.setFieldValue(
          'trprice',
          parseFloat((formik.values.trprice || '0') / currencyData.sum),
          true,
        );
        formik.setFieldValue(
          'tnprice',
          parseFloat((formik.values.tnprice || '0') / currencyData.sum),
          true,
        );
      } else if (value == '0') {
        formik.setFieldValue(
          'repaired',
          parseFloat((formik.values.repaired || '0') * currencyData.sum),
          true,
        );
        formik.setFieldValue(
          'norepaired',
          parseFloat((formik.values.norepaired || '0') * currencyData.sum),
          true,
        );
        formik.setFieldValue(
          'trprice',
          parseFloat((formik.values.trprice || '0') * currencyData.sum),
          true,
        );
        formik.setFieldValue(
          'tnprice',
          parseFloat((formik.values.tnprice || '0') * currencyData.sum),
          true,
        );
        formik.setFieldValue(
          'deal_price',
          parseFloat((formik.values.deal_price || '0') * currencyData.sum),
          true,
        );
      }
    }
  };

  return (
    <div className='sheet-actions-body'>
      <div className='absolute top-0 right-0'>
        <IconButton
          variant='onlyIcon'
          color='primary'
          onClick={() => handleCloseHomeDetail()}
        >
          <i className='bi bi-x' />
        </IconButton>
      </div>
      {/* <Grid container spacing={2} rowSpacing={1} columns={{ xs: 12, sm: 12 }}>
        <Grid item={true} sm={12}>
          <SimpleCheckbox
            delay={0}
            duration={0}
            label={t('shaxmatka.changeMultiple')}
            value={editTypeMultiple}
            setValue={handleEditType}
          />
        </Grid>
      </Grid> */}
      <div className='sheet-form-action'>
        <form onSubmit={formik.handleSubmit}>
          <Grid
            container
            spacing={2}
            rowSpacing={1}
            columns={{ xs: 12, sm: 12 }}
          >
            {!editTypeMultiple && (
              <Grid item={true} sm={12} sx={{ marginBottom: '-0.5rem' }}>
                <FormTextField
                  delay={0}
                  label={t('common.fields.homeNumber')}
                  fieldName='number'
                  formik={formik}
                />
              </Grid>
            )}

            <Grid item={true} sm={12} sx={{ marginBottom: '-0.5rem' }}>
              <FormTextField
                delay={0}
                label={t('common.fields.rooms')}
                fieldName='rooms'
                formik={formik}
              />
            </Grid>

            <Grid item={true} sm={12} sx={{ marginBottom: '-0.5rem' }}>
              <FormNumberField
                delay={0}
                label={t('common.fields.homeAreAll')}
                fieldName='square'
                formik={formik}
                decimalScale={2}
              />
            </Grid>
            <Grid item={true} sm={12} sx={{ marginBottom: '-0.5rem' }}>
              <FormNumberField
                delay={0}
                label={t('shaxmatka.homeDetail.areaTerrace')}
                fieldName='terassa'
                formik={formik}
                decimalScale={2}
              />
            </Grid>

            <Grid item={true} sm={12} sx={{ marginBottom: '-0.5rem' }}>
              <FormCurrencyField
                delay={0}
                fieldName='start'
                formik={formik}
                label={t('common.fields.startPricePercentage')}
                decimalScale={1}
              />
              {formik.values.isvalute == '1' && !isNaN(formik.values.start) && (
                <CurrencySubContent value={formik.values.start || '0'} />
              )}
            </Grid>

            <Grid item={true} sm={12}>
              <FormRadioGroupField
                delay={0}
                fieldName='islive'
                formik={formik}
                label={t('common.fields.residentType')}
                options={residentTypeSelectOptions}
              />
            </Grid>

            <Grid
              item={true}
              sm={12}
              sx={{ marginTop: '-0.5rem', marginBottom: '-0.5rem' }}
            >
              <FormRadioGroupField
                delay={0}
                fieldName='isrepaired'
                formik={formik}
                label={t('common.fields.repairType')}
                options={repairTypeSelectOptions}
              />
            </Grid>

            {/* price fields */}
            <Grid item={true} sm={12}>
              <div className='price-form-item-divider' />
            </Grid>
            <Grid item={true} sm={12} sx={{ marginBottom: '-0.5rem' }}>
              <FormSimpleSelectField
                delay={0}
                fieldName='isvalute'
                formik={formik}
                label={t('common.fields.currency')}
                options={currencyTypeSelectOptions}
                itemValue='code'
                itemLabel='label'
                changeFn={handleCurrencyChange}
              />
            </Grid>

            <Grid item={true} sm={12} sx={{ marginBottom: '-0.5rem' }}>
              <FormCurrencyField
                delay={0}
                fieldName='repaired'
                formik={formik}
                label={
                  <span>
                    <Trans i18nKey='common.fields.repairedPrice'>
                      Ta'mirlangan narxi(1 m<sup>2</sup>)
                    </Trans>
                  </span>
                }
                decimalScale={1}
              />
              {formik.values.isvalute == '1' &&
                !isNaN(formik.values.repaired) && (
                  <CurrencySubContent value={formik.values.repaired || '0'} />
                )}
            </Grid>

            <Grid item={true} sm={12} sx={{ marginBottom: '-0.5rem' }}>
              <FormCurrencyField
                delay={0}
                fieldName='norepaired'
                formik={formik}
                label={
                  <span>
                    <Trans i18nKey='common.fields.noRepairedPrice'>
                      Ta'mirlanmagan narxi(1 m<sup>2</sup>)
                    </Trans>
                  </span>
                }
                decimalScale={1}
              />
              {formik.values.isvalute == '1' &&
                !isNaN(formik.values.norepaired) && (
                  <CurrencySubContent value={formik.values.norepaired || '0'} />
                )}
            </Grid>

            <Grid item={true} sm={12} sx={{ marginBottom: '-0.5rem' }}>
              <FormCurrencyField
                delay={0}
                fieldName='deal_price'
                formik={formik}
                label={
                  <span>
                    <Trans i18nKey='common.fields.dealPrice'>
                      Kelishilgan holda Ta'mirlangan narxi (1 m<sup>2</sup>)
                    </Trans>
                  </span>
                }
                decimalScale={1}
              />
              {formik.values.isvalute == '1' &&
                !isNaN(formik.values.deal_price) && (
                  <CurrencySubContent value={formik.values.deal_price || '0'} />
                )}
            </Grid>
            <Grid item={true} sm={12} sx={{ marginBottom: '-0.5rem' }}>
              <FormCurrencyField
                delay={0}
                fieldName='trprice'
                formik={formik}
                label={
                  <span>
                    <Trans i18nKey='shaxmatka.homeDetail.terassaRepaired'>
                      Kelishilgan holda Ta'mirlangan narxi (1 m<sup>2</sup>)
                    </Trans>
                  </span>
                }
                decimalScale={1}
              />
              {formik.values.isvalute == '1' &&
                !isNaN(formik.values.trprice) && (
                  <CurrencySubContent value={formik.values.trprice || '0'} />
                )}
            </Grid>
            <Grid item={true} sm={12} sx={{ marginBottom: '-0.5rem' }}>
              <FormCurrencyField
                delay={0}
                fieldName='tnprice'
                formik={formik}
                label={
                  <span>
                    <Trans i18nKey='shaxmatka.homeDetail.terassaNoRepaired'>
                      Kelishilgan holda Ta'mirlangan narxi (1 m<sup>2</sup>)
                    </Trans>
                  </span>
                }
                decimalScale={1}
              />
              {formik.values.isvalute == '1' &&
                !isNaN(formik.values.tnprice) && (
                  <CurrencySubContent value={formik.values.tnprice || '0'} />
                )}
            </Grid>

            <Grid item={true} sm={12} xs={12}>
              <FormActionButtons
                delay={0}
                isSubmitting={isSubmitting || isMultipleSubmitting}
                onlySave
                className='mt-0'
              />
            </Grid>
          </Grid>
        </form>
      </div>
    </div>
  );
});
